import * as Immutable from 'immutable';
import {
  GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_ABORTED,
  GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_REQUESTED,
  GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_COMPLETED,
  GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_FAILED,
} from '../../actions/adviserdocumentanalytics/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_REQUESTED:
      return state
        .set('error', null)
        .set('data', null)
        .set('gettingdata', true);

    case GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_ADVISERDOCUMENTREADS_FOR_ACCOUNT_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
